<template>
<div>
  <div class="key-block">
    <el-form-item :label="$locale('global.name')+' *'" class="block-l">
      <el-input v-model="form.name"></el-input>
    </el-form-item>
    <div class="block-r">
      <div class="clearfix">
        <el-form-item :label="$locale('global.price_taxIncluded') + ' *'" class="w153">
          <el-input v-model="form.price" prefix-icon="el-icon-money" @blur="recalculate_fn"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('movie.sorting') + ' *'" class="w153">
          <el-input v-model="form.sort" maxlength="5"></el-input>
        </el-form-item>
        <el-form-item :label="$locale('rules.POSDisplayGroup')" class="w139">
          <el-select v-model="form.groupId" clearable>
            <el-option
              v-for="item in groupList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$locale('rules.ticketCategory') + ' *'" class="w139"> -->
          <el-form-item :label="$locale('rules.ticketCategory')" class="w139">
          <el-select v-model="form.ticketTypeId">
            <el-option
              v-for="item in ticketTypeList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$locale('rules.availableTarget_multi')" class="w415">
          <el-select v-model="form.availableMembers" multiple>
            <el-option
              v-for="item in availableMembersOptions"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$locale('rules.purchaseUnit_sheets')" class="w120">
          <el-select v-model="form.salesNum">
            <el-option
              v-for="item in 10"
              :label="item"
              :value="'' + item + ''"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$locale('rules.tempHoldType')" class="w153">
          <el-select v-model="form.freeHoldSeat">
            <el-option :label="$locale('global.yes')" :value="true" />
            <el-option :label="$locale('global.no')" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label=" " class="w110" v-if="addTicketItem">
          <div class="removeBtn" @click="$emit('itemHandle', 'remove', componentIndex)" v-if="removeIcon">{{$locale("rules.removeTicket")}}</div>
          <!-- <el-button class="handle-btn egl-btn-white-gray-border" @click="$emit('itemHandle', 'remove', componentIndex)" v-if="removeIcon">
            <i class="el-icon-minus"></i>
          </el-button> -->
          <!-- <el-button class="handle-btn egl-btn-white-gray-border" @click="$emit('itemHandle', 'add')" v-if="addIcon">
            <i class="el-icon-plus"></i>
          </el-button> -->
        </el-form-item>
      </div>
      <div class="clearfix">
        <el-form-item :label="$locale('rules.displayDate_multi')" class="w395">
          <el-popover width="395" popper-class="rule-date-popover" trigger="hover">
            <div class="popover-box">
              <div class="time-type">
                <el-radio-group v-model="displayDate" @change="dateRadioChange('displayDate')">
                  <el-radio :label="'all'">{{ $locale("rules.unspecified")}}</el-radio>
                  <el-radio :label="'week'">{{ $locale("calendar.weekly") }}</el-radio>
                  <el-radio :label="'month'">{{ $locale("calendar.monthly") }}</el-radio>
                </el-radio-group>
              </div>
              <div class="week-item clearfix" v-if="displayDate == 'week'">
                <span
                  :class="form.displayDate.week.indexOf(item.value) >= 0 ? 'time-item act' : 'time-item'"
                  v-for="item in dateWeek"
                  :key="item.value"
                  @click="chooseTime('displayDate', 'week', item.value)"
                >{{ item.label }}</span>
              </div>
              <div class="day-item clearfix" v-if="displayDate == 'month'">
                <span
                  :class="form.displayDate.month.indexOf(i + '') >= 0 ? 'time-item act' : 'time-item'"
                  v-for="i in 31"
                  :key="i"
                  @click="chooseTime('displayDate', 'month', i + '')"
                >{{i}}</span>
              </div>
            </div>
            <div slot="reference">
              <el-input v-model="displayDateText" suffix-icon="el-icon-date" readonly></el-input>
            </div>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$locale('rules.undisplayDate_multi')" class="w395">
          <el-popover width="395" popper-class="rule-date-popover" trigger="hover">
            <div class="popover-box">
              <div class="time-type">
                <el-radio-group v-model="unDisplayDate" @change="dateRadioChange('unDisplayDate')">
                  <el-radio :label="'all'">{{ $locale("rules.unspecified") }}</el-radio>
                  <el-radio :label="'week'">{{ $locale("calendar.weekly") }}</el-radio>
                  <el-radio :label="'month'">{{ $locale("calendar.monthly") }}</el-radio>
                </el-radio-group>
              </div>
              <div class="week-item clearfix" v-if="unDisplayDate == 'week'">
                <span
                  :class="form.unDisplayDate.week.indexOf(item.value) >= 0 ? 'time-item act' : 'time-item'"
                  v-for="item in dateWeek"
                  :key="item.value"
                  @click="chooseTime('unDisplayDate', 'week', item.value)"
                >{{ item.label }}</span>
              </div>
              <div class="day-item clearfix" v-if="unDisplayDate == 'month'">
                <span
                  :class="form.unDisplayDate.month.indexOf(i + '') >= 0 ? 'time-item act' : 'time-item'"
                  v-for="i in 31"
                  :key="i"
                  @click="chooseTime('unDisplayDate', 'month', i + '')"
                >{{i}}</span>
              </div>
            </div>
            <div slot="reference">
              <el-input v-model="unDisplayDateText" suffix-icon="el-icon-date" readonly></el-input>
            </div>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$locale('rules.deviceUndisplay_multi')" class="w395">
          <el-select v-model="form.unDisplayDevice" multiple>
            <el-option
              v-for="item in deviceList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="clearfix">
        <el-form-item :label="$locale('rules.notAvailableCoupons_multi')" class="w877">
          <!-- <el-select v-model="form.couponIds" multiple popper-class="rule-multiple-select">
            <el-option disabled value="-1" class="disable">
              <el-row class="select-handle">
                <el-col :span="4">
                  <div @click="selectHandler('select')">
                    <i class="el-icon-check"></i>
                    {{ $locale("global.selectAll") }}
                  </div>
                </el-col>
                <el-col :span="4">
                  <div @click="selectHandler('empty')">
                    <i class="el-icon-close"></i>
                    {{ $locale("global.deselectAll") }}
                  </div>
                </el-col>
              </el-row>
            </el-option>
            <el-option
              v-for="item in couponTypeList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select> -->
          <!-- <remote-select
            v-if="$route.path.indexOf('create') > -1 || formName"
            v-model="form.couponIds"
            :formValue.sync="form.couponIds"
            :actionType="$route.path.indexOf('create') > -1 ? 'create' : 'edit'"
            @selectAll="arr => form.couponIds = arr"
            :isSelectAllFunc="true"
          /> -->
          <RemoteSelectV2
            type="coupon"
            useType="all"
            :list="couponList"
            v-model="form.couponIds"
            :formValue.sync="form.couponIds"
            :fields="['id', 'name']"
            @selectAll="arr => form.couponIds = arr"
            :isSelectAllFunc="true"
            @change="handleChange"
          />
        </el-form-item>
        <el-form-item :label="$locale('rules.notAvailableSpecialSeats_multi')" class="w329">
          <el-select v-model="form.seatsStatus" multiple>
            <el-option
              v-for="item in seatsList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <SellTogether
        :id="type === 'general' ? type : `${type}${index}`"
        v-for="(item, idx) in form.comboItems"
        :data="item"
        :index="idx"
        :key="'combo' + idx"
        @update="updateItem"
        :list="getShopList(item.type)"
        :comboItemsLength="form.comboItems.length"
        :price="form.price"
        :shopItemTotal="$_.sumBy(form.comboItems, function(o) { return Number(o.price); })"
        @updatePrice="form.price = $_.sumBy(form.comboItems, function(o) { return Number(o.price); })"
      />
      <div class="clearfix">
        <el-form-item :label="$locale('rules.ticketAmount')" class="w35">
        <el-input v-model="computedPrice" prefix-icon="el-icon-money" disabled />
      </el-form-item>
      </div>
      <div class="clearfix" v-for="i in form.warningMsg.length" :key="i">
        <el-form-item :label="i == 1 ? $locale('rules.alertMessage') : ''" class="w285">
          <el-select v-model="form.warningMsg[i - 1].deviceType">
            <el-option
              v-for="item in deviceList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              :disabled="isPlatformDisabled(item.value, i - 1)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="i == 1 ? ' ' : ''" class="w850">
          <el-input v-model="form.warningMsg[i - 1].message" :readonly="form.warningMsg[i - 1].deviceType == ''"></el-input>
        </el-form-item>
        <el-form-item :label="i == 1 ? ' ' : ''" class="w110">
          <el-button class="handle-btn egl-btn-white-gray-border" @click="removeWarningMsgItem(i - 1)" v-if="form.warningMsg.length >= 2">
            <i class="el-icon-minus"></i>
          </el-button>
          <el-button class="handle-btn egl-btn-white-gray-border" @click="addWarningMsgItem" v-if="i == form.warningMsg.length && form.warningMsg.length < deviceList.length">
            <i class="el-icon-plus"></i>
          </el-button>
        </el-form-item>
      </div>
    </div>
  </div>
  <div class="key-block">
    <div class="block-l">&nbsp;</div>
    <div class="block-r">
      <el-form-item :label="$locale('rules.mobolize')" class="w153">
        <el-select v-model="form.mobilize" >
          <el-option :value="true" :label="$locale('global.yes')"></el-option>
          <el-option :value="false" :label="$locale('global.no')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$locale('sideMenu.performance.discountRuleTemplate')" class="w153">
        <el-select v-model="form.discountRuleId" >
          <el-option
            v-for="item in discountList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$locale('rules.ticketID.forCurrentCinemaLoyalty')">
        <el-input
          v-model="form.couponNumber"
          maxlength="100"
          :placeholder="$locale('rules.ticketID.forCurrentCinemaLoyalty.placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('rules.cl')" v-if="isCL">
        <el-select
          v-model="form.clCouponId"
          :placeholder="$locale('theatre.p.input')"
          clearable
        >
          <el-option v-for="(item, idx) in injectCLCouponList"
          :key="idx"
          :label="item.name"
          :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </div>
  </div>
</div>
</template>

<script>
import { weekSelectArray } from "@/utils/common";
import { shopTypeEnum } from "@/assets/js/sellTogether.js";
// import RemoteSelect from "@/components/common/RemoteSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import SellTogether from "@/components/RuleTemplate/SellTogether.vue";
import { number_reg } from "@/utils/regExp";

export default {
  name: "ruleTemplateTicketItemModule",
  inject: [ "clCouponList" ],
  data() {
    return {
      form: {
        name: "",
        price: 0,
        sort: "0",
        groupId: "",
        ticketTypeId: "",
        availableMembers: [],
        salesNum: "1",
        freeHoldSeat: false,
        displayDate: {
          all: true,
          week: [],
          month: [],
        },
        unDisplayDate: {
          all: false,
          week: [],
          month: [],
        },
        unDisplayDevice: [],
        couponIds: [],
        seatsStatus: [],
        warningMsg: [],
        mobilize: false,
        discountRuleId: "",
        couponNumber: "",
      },
      availableMembersOptions: [
        {
          label: this.$locale("global.all"),
          value: "all",
        },
        {
          label: this.$locale("global.eigaland"),
          value: "eigaland",
        },
        {
          label: this.$locale("global.cinema"),
          value: "cinema",
        }
      ],
      displayDate: "all",
      displayDateText: "",
      unDisplayDate: "",
      unDisplayDateText: "",
      dateWeek: weekSelectArray,
      deviceList: [
        {
          label: this.$locale("global.POS"),
          value: "POS",
        },
        {
          label: this.$locale("global.scanner"),
          value: "SCANNER",
        },
        {
          label: this.$locale("global.online"),
          value: "WEB",
        },
        {
          label: this.$locale("global.selfCashier"),
          value: "SELFCASHIER",
        }
      ],
      seatsList: [
        {
          label: this.$locale("rules.generalSeat"),
          value: "general",
        },
        {
          label: this.$locale("rules.wheelchair"),
          value: "wheelchair",
        },
        {
          label: this.$locale("rules.VIPSeat"),
          value: "vip",
        },
        {
          label: this.$locale("rules.specialSeat"),
          value: "special",
        },
        // {
        //   label: this.$locale("rules.closeSeat"),
        //   value: "close",
        // },
        // {
        //   label: this.$locale("rules.onlineCloseSeat"),
        //   value: "onlineClose",
        // },
        // {
        //   label: this.$locale("rules.POSCloseSeat"),
        //   value: "posClose",
        // },
        // {
        //   label: this.$locale("rules.accidentCloseSeat"),
        //   value: "accidentClose",
        // },
        // {
        //   label: this.$locale("rules.soldSeat"),
        //   value: "sold",
        // },
        {
          label: this.$locale("rules.loversSeat"),
          value: "lovers",
        },
        {
          label: this.$locale("theatre.seat.windowSeat"),
          value: "posCounter",
        },
      ],
      commercialList: [],
      concessionList: [],
      goodsPackageList: [],
    };
  },
  methods: {
    recalculate_fn(e) {
      const { value } = e.target;
      if (Number(value) < this.$_.sumBy(this.form.comboItems, function(o) {
        return Number(o.price);
      })) {
        this.form.price = this.$_.sumBy(this.form.comboItems, function(o) {
          return Number(o.price);
        });
      }
    },
    dateRadioChange(keyName) {
      let newObj = {
        all: this.form[keyName].all,
        week: [ ...this.form[keyName].week ],
        month: [ ...this.form[keyName].month ],
      };

      if (this[keyName] == "all") {
        newObj.week = [];
        newObj.month = [];
        newObj.all = true;
      } else {
        newObj.all = false;
      }
      this.form[keyName] = newObj;
    },
    chooseTime(keyName, type, val) {
      let newObj = { ...this.form[keyName] };

      if (newObj[type].indexOf(val) >= 0) {
        newObj[type].splice(newObj[type].indexOf(val), 1);
      } else {
        newObj[type].push(val);
      }

      this.form[keyName] = newObj;
    },
    showDateText(objKeyName, textKeyName) {
      let obj = JSON.parse(JSON.stringify(this.form[objKeyName]));
      let text = "";
      let weekOption = [ ...this.dateWeek ];

      if (obj.all) {
        text = this.$locale("rules.unspecified");
      } else {
        let weekText = "";
        let monthText = "";

        obj.week.map(val => {
          for (let i = 0; i < weekOption.length; i++) {
            if (val == weekOption[i].value) {
              weekText = weekText + weekOption[i].label + ",";
              break;
            }
          }
        });

        if (weekText.length > 0) {
          weekText = weekText.substring(0, weekText.length - 1);
          weekText = this.$locale("calendar.weekly") + weekText + this.$locale("calendar.weekday");
        }

        if (obj.month.length > 0) {
          monthText = obj.month.toString();
          monthText = this.$locale("calendar.monthly") + monthText + this.$locale("calendar.day");
        }

        if (weekText != "" && monthText != "") {
          text = weekText + "/" + monthText;
        } else {
          text = weekText + monthText;
        }
      }

      this[textKeyName] = text;
    },
    addWarningMsgItem() {
      if (this.form.warningMsg.length >= this.deviceList.length) { return; }
      let newWarningMsg = [ ...this.form.warningMsg ];
      let warningLength = newWarningMsg.length;

      if (newWarningMsg[warningLength - 1].deviceType != "" && newWarningMsg[warningLength - 1].message != "") {
        newWarningMsg.push({
          deviceType: "",
          message: "",
        });
      }

      this.form = { ...this.form, warningMsg: newWarningMsg };
    },
    removeWarningMsgItem(i) {
      let newWarningMsg = [ ...this.form.warningMsg ];

      newWarningMsg.splice(i, 1);
      this.form = { ...this.form, warningMsg: newWarningMsg };
    },
    isPlatformDisabled(platformValue, currentIdx) {
      return this.form.warningMsg.some((msg, idx) => idx !== currentIdx && msg.deviceType === platformValue);
    },
    selectHandler(act) {
      let arr = [];

      if (act == "select") {
        this.couponTypeList.map(item => {
          arr.push(item.id);
        });
      }

      this.form = { ...this.form, couponIds: arr };
    },
    updateItem(type, index) {
      if (type === "add") {
        this.form.comboItems.push({
          type: "",
          id: "",
          price: null,
        });
      } else {
        this.form.comboItems.splice(index, 1);
      }
    },
    getShopList(type) {
      const shopTypeListEnum = {
        "concession": this.concessionList,
        "commercial": this.commercialList,
        "goodsPackage": this.goodsPackageList,
      };
      return shopTypeListEnum[type];
    },
    setComboItems_fn(form) {
      if (!form.comboItems || form.comboItems.length === 0) {
        form.comboItems = [ {
          id: "",
          price: null,
          type: ""
        } ];
      }
      if (form.comboItems.some(item => item.type === "commercial")) {
        shopTypeEnum["commercial"]({
          approve: true,
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.commercialList = res.data.data.filter(item => item.commercialTypeEnum === "default")
            .map(shop => ({
              id: shop.id,
              name: shop.name,
              price: shop.price,
            }));
        });
      }
      if (form.comboItems.some(item => item.type === "concession")) {
        shopTypeEnum["concession"]({
          approve: true,
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.concessionList = res.data.data.map(item => ({
            id: item.id,
            name: item.name,
            price: item.price,
          }));
        });
      }
      if (form.comboItems.some(item => item.type === "goodsPackage")) {
        shopTypeEnum["goodsPackage"]({
          approve: true,
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.goodsPackageList = res.data.data.map(item => ({
            id: item.id,
            name: item.name,
            price: item.price,
          }));
        });
      }
    },
    validatePrice(val) {
      if (!number_reg.test(val)) {
        this.form.comboBoxOfficePrice = null;
      }
    },
    handleChange(value) {
      if (value.includes("all")) {
        this.form.couponIds = ['all'];
      }
    },
  },
  computed: {
    injectCLCouponList() {
      return this.clCouponList();
    },
    computedPrice() {
      return this.form.price - this.$_.sumBy(this.form.comboItems, function(o) {
        return Number(o.price);
      });
    }
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
    groupList: {
      type: Array,
      default: () => [],
    },
    ticketTypeList: {
      type: Array,
      default: () => [],
    },
    couponTypeList: {
      type: Array,
      default: () => [],
    },
    addTicketItem: {
      type: Boolean,
      default: false,
    },
    addIcon: {
      type: Boolean,
      default: false,
    },
    removeIcon: {
      type: Boolean,
      default: false,
    },
    componentIndex: {
      type: Number,
      default: 0,
    },
    discountList: {
      type: Array,
      default: () => [],
    },
    formName: {
      type: String,
      default: "",
    },
    couponList: {
      type: Array,
      default: () => [],
    },
    isCL: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
  },
  mounted() {
    let form = { ...this.form, ...this.formObj };
    if (form.warningMsg.length == 0) {
      form.warningMsg.push({
        deviceType: "",
        message: "",
      });
    }
    this.setComboItems_fn(form);
    this.form = form;
  },
  watch: {
    formObj() {
      let form = { ...this.form, ...this.formObj };

      if (form.warningMsg.length == 0) {
        form.warningMsg.push({
          deviceType: "",
          message: "",
        });
      }
      this.setComboItems_fn(form);
      if (this.formObj.displayDate.all) {
        this.displayDate = "all";
      } else if (this.formObj.displayDate.week.length > 0) {
        this.displayDate = "week";
      } else {
        this.displayDate = "month";
      }

      if (this.formObj.unDisplayDate.all) {
        this.unDisplayDate = "all";
      } else if (this.formObj.unDisplayDate.week.length > 0) {
        this.unDisplayDate = "week";
      } else if (this.formObj.unDisplayDate.month.length) {
        this.unDisplayDate = "month";
      }

      this.form = form;
    },
    "form.displayDate"() {
      this.showDateText("displayDate", "displayDateText");
    },
    "form.unDisplayDate"() {
      this.showDateText("unDisplayDate", "unDisplayDateText");
    },
  },
  components: {
    RemoteSelectV2,
    SellTogether
  }
};
</script>
